import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const selectAppRecommendationIdData = state => state.app.recommendationIdData;
const selectGlobalUpNextHeadline = state => state.globalVideo.upNextHeadline;
const selectGlobalUpNextVideo = state => state.globalVideo.nextVideos;
const selectGlobalVideoPanelVideo = state => state.globalVideo.panelVideo;
const selectGlobalVideoRestartVideo = state => state.globalVideo.restartVideo;
const selectGlobalVideoVideo = state => state.globalVideo.video;

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

export const makeSelectGlobalVideoRestartVideo = createDeepEqualSelector(
  selectGlobalVideoRestartVideo,
  restartVideo => restartVideo,
);

export const makeSelectGlobalVideoVideo = createDeepEqualSelector(
  selectGlobalVideoVideo,
  video => video,
);

export const makeSelectGlobalUpNextVideo = createDeepEqualSelector(
  selectGlobalUpNextVideo,
  video => video,
);

export const makeSelectGlobalUpNextHeadline = createDeepEqualSelector(
  selectGlobalUpNextHeadline,
  video => video,
);

export const makeSelectGlobalVideoPanelVideo = createDeepEqualSelector(
  selectGlobalVideoPanelVideo,
  panelVideo => panelVideo,
);

export const makeSelectAppRecommendationIdData = createDeepEqualSelector(
  selectAppRecommendationIdData,
  recommendationIdData => recommendationIdData,
);
